import React, { useState } from 'react';
import { FaFilePdf, FaChevronRight, FaEnvelope } from 'react-icons/fa';
// import QuoteModal from './QuoteModal';
import WhatsAppModal from './WhatsAppModal';

import Header from './Header';
import Footer from './Footer';
import '../styles/VisionSensor.css';

import introImage from '../assets/akusense1.png';
import tab1Image from '../assets/VDS10-BH0106-RP.jpg';
import tab2Image from '../assets/RCD-AI100-X08R.jpg';

import VisionSensorPdfMain from '../assets/Vision sensor_Catalogue 2024_K-AI Image Recognition.pdf';
import VisionSensorSpecification from '../assets/Vision Sensor Specification.pdf';
import VDS10_SERIES from '../assets/AI-IMAGE-RECOGNITION-VISION-SENSOR-_VDS10-SERIES.pdf';
import VDS20_SERIES from '../assets/VDS20C AKU.pdf';
import VisionSensorSpecsImg from '../assets/Vision Sensor Specification IMG.png';

export default function VisionSensor() {
  const [activeTab, setActiveTab] = useState('vds10');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="VisionSensor-wrapper">
      <Header />

      <div className="hero-banner25">
        <div className="hero-banner25-content">
          <h1>AI IMAGE RECOGNITION</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>AI Image Recognition</span>
          </div>
        </div>
      </div>

      <section className="sensor-main-content">
        <div className="sensor-description-block">
          <img src={introImage} alt="AI Vision Sensor" />
          <div>
            <h2>AI Image Recognition</h2>
            <ul>
              <li>AI-powered Intelligent Inspection toolset</li>
              <li>Liquid focus technology</li>
              <li>Highly precise positioning algorithm and detection algorithm</li>
              <li>Modular solution with integrated light source</li>
              <li>Compact size for simple installation</li>
            </ul>
            <div className="sensor-buttons">
              <a href={VisionSensorPdfMain} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>
              </a>
              <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
              {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
                    {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

            </div>
          </div>
        </div>

        {/* Category Tabs */}
        <div className="sensor-tabs">
          <button className={activeTab === 'vds10' ? 'active' : ''} onClick={() => setActiveTab('vds10')}>
            Vision Series VDS10 Series
          </button>
          <button className={activeTab === 'vds20' ? 'active' : ''} onClick={() => setActiveTab('vds20')}>
            Vision Sensor VDS20C Series
          </button>
          <button className={activeTab === 'specs' ? 'active' : ''} onClick={() => setActiveTab('specs')}>
            Technical Specifications
          </button>
        </div>

        {/* Category Content */}
        <div className="sensor-tab-content">
          {activeTab === 'vds10' && (
            <div className="level-product-table">
              <div className="sensor-feature-card">
                <img src={tab1Image} alt="VDS10 Sensor" />
                <h3>Vision Series<br />VDS10 Series</h3>
                <a href={VDS10_SERIES} target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="sensor-right">
                <table className="switch-spec-table">
                  <tbody>
                    <tr><td>Capture Frame Rate</td><td>60 fps</td></tr>
                    <tr><td>Resolution (HxV)</td><td>1280×800</td></tr>
                    <tr><td>Exposure Time</td><td>20us~10000us</td></tr>
                    <tr><td>Focal Length</td><td>6mm - 16mm</td></tr>
                    <tr><td>Operating Temperature</td><td>0~45°C</td></tr>
                    <tr><td>Storage Temperature</td><td>-20~70°C</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'vds20' && (
            <div className="level-product-table">
              <div className="sensor-feature-card">
                <img src={tab2Image} alt="VDS20 Sensor" />
                <h3>VISION SENSOR<br />VDS20C Series</h3>
                <a href={VDS20_SERIES} target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="sensor-right">
                <table className="switch-spec-table">
                  <tbody>
                    <tr><td>Frame Rate</td><td>60 fps</td></tr>
                    <tr><td>Operating Distance</td><td>100~1000mm</td></tr>
                    <tr><td>Focal Length</td><td>6mm</td></tr>
                    <tr><td>Operating Temperature</td><td>0~45°C</td></tr>
                    <tr><td>Storage Temperature</td><td>-20~70°C</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'specs' && (
            <div className="VisionSensorSpecs-image-wrapper">
              <img src={VisionSensorSpecsImg} alt="Vision Sensor Technical Specifications" className="VisionSensorSpecs-img" />
              <div className="VisionSensorSpecs-download-btn">
                <a href={VisionSensorSpecification} target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn">
                    <FaFilePdf style={{ marginRight: '8px' }} /> Download
                  </button>
                </a>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
